import React from "react";

// Define all available feature flags as a union type
export type FeatureFlag =
  // Add new feature flags here as you create them
  "SEND_FOR_REVIEW"; // Remove this once you have real flags

// Check if a feature flag is enabled
export function isFeatureEnabled(flag: FeatureFlag): boolean {
  const envKey = `VITE_FEATURE_${flag}` as keyof ImportMetaEnv;
  const value = import.meta.env[envKey];

  // Convert string values to boolean
  if (typeof value === "string") {
    return value.toLowerCase() === "true";
  }

  return Boolean(value);
}

// React component for conditional rendering based on feature flags
export function FeatureFlag({
  flag,
  children,
  fallback = null,
}: {
  flag: FeatureFlag;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}): React.ReactNode {
  return isFeatureEnabled(flag)
    ? React.createElement(React.Fragment, null, children)
    : React.createElement(React.Fragment, null, fallback);
}
